export default [
  {
    code: 'courses.index',
    name: 'courses.index',
    meta: {
      title: 'Courses',
      icon: 'mdi-flask',
      authenticatable: true,
      sort: 500,
      permission: 'users.index',
    }
  }
]
